// utilitário para formatar o nome da criança + suas turmas

const CURRENT_YEAR = new Date().getFullYear()

function truncateWithEllipsis (str, maxLength) {
  if (str.length <= maxLength) return str
  if (maxLength <= 3) return '.'.repeat(maxLength)
  return str.slice(0, maxLength - 3) + '...'
}

function sortClassrooms (classrooms) {
  return (classrooms || []).slice().sort(function (a, b) {
    return (b.is_main_classroom ? 1 : 0) - (a.is_main_classroom ? 1 : 0)
  })
}

function findFirstClassroomOfYear (classrooms, year) {
  let sorted = sortClassrooms(classrooms)
  return sorted.find(function (c) {
    return c.year === year
  })
}

function getAllClassroomsOfYear (classrooms, year) {
  let sorted = sortClassrooms(classrooms)
  return sorted.filter(function (c) {
    return c.year === year
  })
}

export function buildShortText (items, maxLen = 48) {
  let parts = items.map(function (item) {
    let child = item.child || {}
    let classrooms = child.classrooms || []

    let classroom = findFirstClassroomOfYear(classrooms, CURRENT_YEAR)

    if (!classroom) {
      return child.name
    }

    return child.name + ' - ' + classroom.name
  })

  let full = parts.join(' / ')
  return truncateWithEllipsis(full, maxLen)
}

export function buildTooltipText (items) {
  let parts = items.map(function (item) {
    let child = item.child || {}
    let classrooms = child.classrooms || []

    let classroomsYear = getAllClassroomsOfYear(classrooms, CURRENT_YEAR)

    if (classroomsYear.length === 0) {
      return child.name
    }

    let nomesTurmas = classroomsYear
      .map(function (c) {
        return c.name
      })
      .join(', ')

    return child.name + ' - ' + nomesTurmas
  })

  return parts.join(' / ')
}
